import React from 'react';
interface CityWordmarkProps {
  cityName: string;
  color: string;
  /** Text colour on a coloured band. */
  inverted?: boolean;
  large?: boolean;
}
const BROSSARD_GREEN = '#3C9A3F';
/** Quadrant rotations: four "b" turning around the centre, like a highway interchange. */
const QUADRANTS = [{
  x: 0,
  y: 0,
  r: 0
}, {
  x: 21,
  y: 0,
  r: 90
}, {
  x: 21,
  y: 21,
  r: 180
}, {
  x: 0,
  y: 21,
  r: 270
}];

/**
 * Fallback city wordmark when no logo file is uploaded.
 * Brossard: redrawn after the city's published description of its logo
 * (four green "b" arranged like an interchange, followed by "brossard").
 * Upload the official file in Configurer → Identité to replace it.
 */
export function CityWordmark({
  cityName,
  color,
  inverted = false,
  large = false
}: CityWordmarkProps) {
  const size = large ? 30 : 22;
  if (cityName === 'Brossard') {
    const fg = inverted ? '#FFFFFF' : BROSSARD_GREEN;
    const bg = inverted ? BROSSARD_GREEN : '#FFFFFF';
    return <span className="inline-flex items-center gap-1.5" aria-label="Ville de Brossard" data-id="element-4048" data-mp="3bgodt7cne0a7">
        <svg width={size} height={size} viewBox="0 0 41 41" aria-hidden="true" data-id="element-4049" data-mp="2c9o0vhkkir1y">
          {QUADRANTS.map(q => <g key={q.r} transform={`translate(${q.x} ${q.y}) rotate(${q.r} 10 10)`} data-id="element-4050" data-mp="2l4b0ty7gqb6t">
              <rect width="20" height="20" rx="2.5" fill={fg} data-id="element-4051" data-mp="2l65d6o4o4uza" />
              <text x="10" y="16.5" textAnchor="middle" fontSize="19" fontWeight="800" fontFamily="Arial, Helvetica, sans-serif" fill={bg} data-id="element-4052" data-mp="2h392rkpa856f">
                b
              </text>
            </g>)}
        </svg>
        <span className={`${large ? 'text-[28px]' : 'text-[21px]'} font-extrabold lowercase leading-none tracking-[-0.04em]`} style={{
        color: inverted ? '#FFFFFF' : '#141414'
      }} data-id="element-4053" data-mp="1xeqagu8zcbni">
          brossard
        </span>
      </span>;
  }
  return <span className="inline-flex items-center gap-2" data-id="element-4054" data-mp="38vzqf6swglk2">
      <span className={`${large ? 'w-9 h-9 text-base' : 'w-7 h-7 text-xs'} shrink-0 rounded-full flex items-center justify-center font-bold`} style={inverted ? {
      backgroundColor: 'rgba(255,255,255,0.18)',
      color: '#fff'
    } : {
      backgroundColor: color,
      color: '#fff'
    }} aria-hidden="true" data-id="element-4055" data-mp="26hacqriw1lk7">
        {cityName.charAt(0)}
      </span>
      <span className={`${large ? 'text-lg' : 'text-sm'} font-bold tracking-tight`} style={{
      color: inverted ? '#fff' : color
    }} data-id="element-4056" data-mp="2kdw21e4ou230">
        Ville de {cityName}
      </span>
    </span>;
}